import { defaultEtapa, EtapaProps } from "./EtapaInterface";

// Definición de defaults

export const defaultSubEtapa: SubEtapaProps = {
    idSubEtapa:            0,
    descripcion:           '',
    activo:                false,
    idEtapa:               0,
    etapa:                 defaultEtapa,
}

// Creación de interfaces

export interface SubEtapaProps {
    idSubEtapa:            number;
    descripcion:           string;
    activo:                boolean;
    idEtapa?:              number;
    etapa?:                EtapaProps;    

}